import { render } from "./WebsitesTable.vue?vue&type=template&id=226ac669&scoped=true"
import script from "./WebsitesTable.vue?vue&type=script&lang=js"
export * from "./WebsitesTable.vue?vue&type=script&lang=js"

import "./WebsitesTable.vue?vue&type=style&index=0&id=226ac669&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226ac669"]])

export default __exports__